import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from '../../utils/StyledRow'
import DiscountBox from './DiscountBox'
import { GA_ENHANCED_ECOMMERCE } from '../../../constants'
import styled from 'styled-components'

const DiscountRow = styled(Row)`
  display: -ms-flexbox;
  -ms-flex-direction: row;
  -ms-flex-pack: justify;
  -ms-flex-wrap: wrap;
`

class DiscountsContainer extends Component {
  componentDidMount () {
    this.props.googleAnalytics.event(GA_ENHANCED_ECOMMERCE.IMPRESSION_PAYLOAD)
  }

  componentDidUpdate () {
    this.props.googleAnalytics.event(GA_ENHANCED_ECOMMERCE.IMPRESSION_PAYLOAD)
  }

  render () {
    const {
      boxes,
      googleAnalytics,
      utmParams
    } = this.props

    if (!boxes || !boxes.length) {
      return null
    }

    return (
      <DiscountRow>
        {
          boxes.map((box, index) => {
            return <DiscountBox
              key={box.guid}
              position={index}
              box={box}
              googleAnalytics={googleAnalytics}
              utmParams={utmParams}
            />
          })
        }
      </DiscountRow>
    )
  }
}

DiscountsContainer.propTypes = {
  boxes: PropTypes.array.isRequired,
  utmParams: PropTypes.object.isRequired,
  googleAnalytics: PropTypes.object
}

export default DiscountsContainer
